import { Translate } from 'react-redux-i18n'
import { languages } from '../../../../../../../configs/language'
import { formatText } from '../../../../../../helpers/value'

const mapLanguage = {
  [languages.en]: 'userManagement.orderManagement.orderDetail.ENGLISH',
  [languages.vi]: 'userManagement.orderManagement.orderDetail.VIETNAMESE',
}
export const LanguageCell = ({ val }) => {
  return <Translate value={formatText(mapLanguage[val])} />
}
